import type { CustomEdge } from '@src/components/custom-nodes/types';

const sharedEdgeAttrs = (isSealed: boolean) => ({
	"markerEnd": {
			"type": isSealed ? undefined : "arrow"
	},
	"type": 'smoothstep',
	style: {
		stroke: isSealed ? 'transparent' : undefined,
		strokeOpacity: isSealed ? 0 : 1,
		opacity: isSealed ? 0 : 1,
		pointerEvents: isSealed ? 'none' : 'auto',
	}
}) as CustomEdge;

export const dehydrateEdgeAttrs = (edge: CustomEdge) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { markerEnd, type, ...rest } = edge;

	return rest;
}

export const hydrateEdgeAttrs = (edge: Partial<CustomEdge>, isSealed: boolean) => {
	return {
		...sharedEdgeAttrs(isSealed),
		...edge,
	} as CustomEdge;
}
